import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDontBox24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconDoAndDontBox24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 12.051v5.551a3.5 3.5 0 0 0 3.5 3.5h5.551v-1.5H6.5a2 2 0 0 1-2-2v-5.55zM12.051 4.5h5.551a2 2 0 0 1 2 2v5.551h1.5V6.5a3.5 3.5 0 0 0-3.5-3.5h-5.55zm9.651 10.676a.75.75 0 0 1 0 1.06l-3.708 3.709-.53.53-.53-.53-1.93-1.93a.75.75 0 1 1 1.06-1.061l1.4 1.4 3.178-3.178a.75.75 0 0 1 1.06 0M4.024 4.024a.75.75 0 0 1 1.06 0L6.592 5.53l1.506-1.506a.75.75 0 0 1 1.06 1.06L7.651 6.592l1.506 1.506a.75.75 0 1 1-1.06 1.06L6.59 7.652 5.085 9.158a.75.75 0 0 1-1.061-1.061L5.53 6.59 4.024 5.085a.75.75 0 0 1 0-1.06"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDoAndDontBox24);
